import { Link } from "react-router"
import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"

export default function CTASection() {
  return (
    <section className="py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-primary px-8 py-20 sm:px-16 sm:py-28 text-center">
          {/* Green top accent bar */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 h-0.75 w-24 bg-[#1D591B] rounded-full" />

          {/* Subtle background texture */}
          <div className="absolute inset-0 opacity-[0.03] cta-dot-pattern" />

          <div className="relative z-10 max-w-3xl mx-auto">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white text-balance leading-[1.1] tracking-tight mb-8">
              {"Ready to navigate the connection queue with confidence?"}
            </h2>

            <p className="text-base sm:text-lg text-white/50 text-balance max-w-xl mx-auto mb-12 leading-relaxed">
              {
                "Join investment professionals using Kanu Energy to identify high-potential projects in the 125 GW pipeline."
              }
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                size="lg"
                className="text-base px-8 md:min-w-56 h-12 bg-white/90 text-[#0D0D0D] font-semibold hover:bg-secondary/90 border-0 rounded-lg shadow-none transition-all duration-200"
                asChild
              >
                <Link to="/waitlist">
                  Join Waitlist <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="text-base px-8 md:min-w-56 h-12 bg-transparent text-white border border-white/20 hover:bg-white/5 hover:border-white/40 rounded-lg shadow-none transition-all duration-200"
              >
                Contact Sales
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
